import storee from './storee';

const store = storee();
export default store;
